export default "__VITE_ASSET__Cka$S5q$__"